import { ReactNode } from "react";
import * as Styled from "./ButtonSkeleton.styled";

const ButtonSkeleton: React.FC<{ children: ReactNode }> = ({ children }) => (
  <Styled.Skeleton variant="rounded">{children}</Styled.Skeleton>
);

export default ButtonSkeleton;
